import { Box, Flex, Image, Link, Text } from "@chakra-ui/react";
import Logo from "../../../../assets/logo.png";

export function RegisterAccountSuccess() {
  return (
    <Flex
      w="100vw"
      h="100vh"
      justifyContent="center"
      alignItems="center"
      px={40}
      py={20}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width={400}
      >
        <Image src={Logo} width={400} alt="Etank" />

        <Text mt={5} textAlign="center" fontSize="36px" color="gray.800">
          Conta criada com sucesso
        </Text>

        <Flex mt={5} alignItems="center" justifyContent="center">
          <Link href="/login" color="green.500" fontWeight="bold">
            Voltar
          </Link>
        </Flex>
      </Box>
    </Flex>
  );
}
